import React, { useState } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { Select, Row, Col } from 'antd';
import PhoneMenu from '../PhoneMenu';
import { Link } from "react-router-dom";
const { Option } = Select;

export default function HeaderNav() {
    // eslint-disable-next-line
    const [actualLanguage, setActualLanguage] = useState('Português')
    const { t, i18n } = useTranslation()

    const changeLanguage = (value) => {
        if (value === 'pt') {
            i18n.changeLanguage('pt')
            // setActualLanguage('en-US')
        } 
        else if(value === 'en'){
            i18n.changeLanguage('en')
            // setActualLanguage('pt-BR')
        }
        else {
            i18n.changeLanguage('es')
            // setActualLanguage('es-E')
        }
    }

    return (
        <>
            <Row>
                <Col xs={0} sm={0} md={24} lg={24} xl={24}>
                    <HeaderDiv>
                        <Navigation>
                            <Ul>
                                <Li><Link to='/' style={{marginTop: '60px'}} >{t('Home')}</Link></Li>
                                <Li><Link to='/projetos'>{t('Projetos')}</Link></Li>
                                <Li><Link to='/techs'>{t('Techs')}</Link></Li>
                                <Li><Link to='/certificados'>{t('Certificados')}</Link></Li>
                            </Ul>
                        </Navigation>
                        <div style={{width: 'auto'}}>
                            <Select defaultValue={actualLanguage} onChange={changeLanguage}>
                                <Option value="pt">Português</Option>
                                <Option value="en">Inglês</Option>
                                {/* <Option value="es">Espanhol</Option> */}
                            </Select>
                        </div>
                    </HeaderDiv>
                </Col>
                <Col xs={24} sm={24} md={0} lg={0} xl={0}>
                    <Phone>
                       <PhoneMenu />
                    </Phone>
                </Col>
            </Row>
        </>
    )
}


const HeaderDiv = styled.div`
    height: 64px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 50px;
`

const Phone = styled.div`
    height: 64px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0 18px;
`

const Navigation = styled.div`
    height: 64px;
    width: auto;
    display: flex;
    justify-content: center;
    align-items: center;
`

const Ul = styled.ul`
    list-style-type: none;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    margin: 0;
`

const Li = styled.li`
    height: 64px;
    margin: 0 12px;
    color: white;
    cursor: pointer;
    transition: all .3s;

    &:hover {
        transform: scale(1.1);
    }
`